<template>
  <div id="custom_template">
    <div v-if="loading">
      <div class="loading-container">
        <div class="loader"></div>
        <p>Loading</p>
      </div>
    </div>

    <langham-authed
      v-if="member && !loading" 
      :member="memberInfo"
      v-on:emitClickedJoin="handleClickedJoin"
    />

    <div v-if="!member && !loading">
      <header class="container-fluid">
        <img class="logo" src="@/components/custom/langhamBostonBrilliant/img/logo_en.svg" />
        <div class="banner">
          <div class="banner-img">
            <img class="large-banner" src="@/components/custom/langhamBostonBrilliant/img/LanghamBostonBanner.jpg" />
            <img class="mobile-banner" src="@/components/custom/langhamBostonBrilliant/img/LanghamBostonMobile.jpg" />
          </div>
          <div class="bottom-left-ribbon"></div>
          <div class="banner-text">
            <h3 class="title">Connect With Us</h3>
            <p class="subtitle">Enjoy Premium Wifi and unlock a range of member-only benefits</p>
          </div>
        </div>
        <div class="lang-select">
          
        </div>
      </header>
      <main class="container-fluid">
        <langham-form
          v-if="load_states.has_custom_portal"
          
          v-on:emitRegistrationMethodData="emitRegistrationMethodData"
          v-on:emitJoined="updateJoined"
          :registration_methods="registration_methods"
          :clickedJoin="clickedJoin"

        />
        <div v-if="load_states.error">
          <div class="error-container">
            <p>{{ error ? error.message : 'Error' }}</p>
            <a v-on:click="changeLoadState('has_custom_portal')" class="error-button">Please try again</a>
          </div>
        </div>
        <div v-if="load_states.loading">
          <div class="loading-container">
            <div class="loader"></div>
            <p>Loading</p>
          </div>
        </div>

        <langham-connected
          v-if="load_states.connected" 
          :joined="joined"
          :portal="portal"
          v-on:emitClickedJoin="handleClickedJoin"
        />

      </main>
      <footer class="container-fluid">
        <div class="logo-container">
          <div class="brilliant-logo">
            <a href="#" target="_self">
              <img class="lazy" src="@/components/custom/langhamBostonBrilliant/img/footer_brilliant.png">
            </a>
          </div>
          <div class="icon-content">
            <ul>
              <li>
                <a href="#" target="_blank">
                  <img class="footer-header-icons" height="90" width="228" src="@/components/custom/langhamBostonBrilliant/img/brand_LHG.png">
                </a>
              </li>

              <li>
                <a href="#" target="_blank">
                  <img class="footer-header-icons" height="90" width="168" src="@/components/custom/langhamBostonBrilliant/img/brand_Cordis.png">
                </a>
              </li>

              <li>
                <a href="#" target="_blank">
                  <img class="footer-header-icons" height="134" width="179" src="@/components/custom/langhamBostonBrilliant/img/Eaton.png">
                </a>
              </li>

              <li>
                <a href="#" target="_blank">
                  <img class="footer-header-icons" height="90" width="273" src="@/components/custom/langhamBostonBrilliant/img/Ying'n_flow_white.png">
                </a>
              </li>

              <li>
                <a href="#" target="_blank">
                  <img class="footer-header-icons" height="90" width="159" src="@/components/custom/langhamBostonBrilliant/img/brand_Chelsea.png">
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-bottom-container">
          <div class="bottom-address-header">
            <p>BRILLIANT BY LANGHAM</p>
          </div>
          <div class="address-list"></div>
          <div class="contact-infobar">
            <p><a href="mailto:enquiry@brilliantbylangham.com">enquiry@brilliantbylangham.com</a></p>
          </div>
          <div class="bottom-separator"></div>
          <div class="social-icon">
            <p>Connect with us on</p>
            <ul class="social-icons-list">
              <li>
                <a href="https://www.facebook.com/BrilliantbyLangham" target="_blank">
                  <img class="bottom-social-icons lazy" src="@/components/custom/langhamBostonBrilliant/img/facebookIcon.png" width="42" height="32" alt="Facebook">
                </a>
              </li>

              <li>
                <a href="https://www.instagram.com/brilliant.bylangham/" target="_blank">
                  <img class="bottom-social-icons lazy" src="@/components/custom/langhamBostonBrilliant/img/instagramIcon.png" width="42" height="32" alt="Instagram">
                </a>
              </li>

              <li>
                <a href="https://www.brilliantbylangham.com/en/brilliant-WeChat-official-account" target="_self">
                  <img class="bottom-social-icons lazy" src="@/components/custom/langhamBostonBrilliant/img/wechatIcon.png" width="42" height="32" alt="微信">
                </a>
            </li>

              <li>
                <a href="https://weibo.com/7899027395" target="_blank">
                  <img class="bottom-social-icons lazy" src="@/components/custom/langhamBostonBrilliant/img/wiboIcon.png" width="42" height="32" alt="微博">
                </a>
              </li>
            </ul>
          </div>
          <div class="bottom-separator"></div>
          <div class="bottom-content-navigator">
            <ul>
              <li><a href="https://www.langhamhospitalitygroup.com/en/" target="_blank">LANGHAM HOSPITALITY GROUP</a></li>
              <li><a href="https://www.langhamhospitalitygroup.com/en/media/" target="_blank">MEDIA CENTRE</a></li>
              <li><a href="https://www.brilliantbylangham.com/en/faq" target="_self">FAQ</a></li>
              <li><a href="https://www.brilliantbylangham.com/en/forms/contact-us" target="_self">CONTACT US</a></li>
            </ul>
          </div>
          <div class="bottom-separator mobile-alg"></div>
          <div class="footer-content-navigator">
            <ul class="navigation-list">
              <li><a href="https://www.brilliantbylangham.com/en/programme-terms-conditions" target="_self">PROGRAMME TERMS &amp; CONDITIONS</a></li>
              <li><a href="https://www.brilliantbylangham.com/en/privacy-policy" target="_self">PRIVACY POLICY</a></li>
              <li><a href="https://www.brilliantbylangham.com/en/cookies-policy" target="_self">COOKIES</a></li>
            </ul>
          </div>
          <div class="copyrights-list">
              <p>COPYRIGHT ©BRILLIANT LOYALTY PROGRAM LIMITED </p>
              <p><a href="https://beian.miit.gov.cn/">沪ICP备2024050525</a></p>
          </div>
        </div>
      </footer>
    </div>
  
  </div>
</template>

<script>
import $ from 'jquery'
import {HTTP} from '@/utilities/http'
import LanghamForm from '@/components/custom/langhamBostonBrilliant/langhamForm'
import LanghamConnected from '@/components/custom/langhamBostonBrilliant/langhamConnected'
import LanghamAuthed from '@/components/custom/langhamBostonBrilliant/langhamAuthed'

export default {
  name: 'custom_template',
  props: [
    'portal',
    'connection_data',
    'load_states',
    'error',
  ],
  components: {
    'langham-form': LanghamForm,
    'langham-connected': LanghamConnected,
    'langham-authed': LanghamAuthed
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    'doc.selected_rm': function(){
      this.doc.selected_tos = null;
    },
  },
  data(){
    return{
      loading: true,
      member: false,
      memberInfo: {},
      joined: false,
      clickedJoin: false,
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        support_phone: '8772822519',
      },
      registration_methods: [],
      // Manually setting this up here because not in endpoint
      terms_of_service: `<center><b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center><br><br><b>ACCEPTANCE OF TERMS THROUGH USE</b><br>By using these services (the "Services"), you agree to all terms, conditions, and notices contained herein. The Hotel reserves the right, in its sole discretion, to terminate your access to all or part of the Services, with or without notice.<br><br><b>DISCLAIMER OF WARRANTIES</b><br>ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE BY THE HOTEL ARE PROVIDED "AS IS". THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES ACCEPT NO LIABILITY FOR ANY PROBLEMS ASSOCIATED WITH YOUR USE OF THE SERVICES, INCLUDING, BUT NOT LIMITED TO, DAMAGE TO YOUR SOFTWARE, HARDWARE, OR OTHER EQUIPMENT; ANY DELAY IN OPERATION OR TRANSMISSION OF THE SERVICES; ANY COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION; ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ON-LINE SYSTEMS, SERVERS, PROVIDERS, OR COMPUTER EQUIPMENT; OR ANY TRAFFIC CONGESTION OF FAILURE OF THE INTERNET OR ANY WEB SITE. THE SERVICES ARE PROVIDED WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NONINFRINGEMENT. THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES DO NOT WARRANT THAT THE SERVICES ARE ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICES WILL BE UNINTERRUPTED OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; THAT THE SERVICES ARE SECURE OR THAT ANY WIRELESS OR WIRED CONNECTION WILL NOT BE ACCESSED, INTERCEPTED, ALTERED OR DESTROYED IN WHOLE OR IN PART BY AN UNAUTHORIZED THIRD PARTY; THAT ANY DATA FILES, PROGRAMS, PROCEDURES OR INFORMATION (INCLUDING YOUR PERSONALLY IDENTIFIABLE INFORMATION) DOWNLOADED, RECORDED, TRANSMITTED OR INPUT THROUGH THE SERVICES WILL BE SECURE OR PROTECTED FROM UNAUTHORIZED ACCESS TO, ALTERATION, DELETION, DEFECT OR DESTRUCTION; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT OR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN WARRANTIES, SO THESE EXCLUSIONS MAY NOT APPLY TO YOU.<br><br><b>LIMITATION OF LIABILITY</b><br>UNDER NO CIRCUMSTANCES SHALL THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER OR ITS REPRESENTATIVES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE, THE SERVICES. THIS LIMITATION APPLIES EVEN IF THE HOTEL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE HOTEL'S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.<br><br><b>INDEMNIFICATION</b><br>You shall defend, indemnify and hold the Hotel and its owners, subsidiaries and other affiliated companies, and their employees, contractors, officers, and directors harmless from all liabilities, claims, and expenses, including attorney's fees resulting from your use or misuse of the Services.<br><br><b>THIRD PARTY SITES</b><br>Your use of the Services may business center you to other sites on the Internet. These sites may contain information or material that some people may find inappropriate or offensive. These other sites are not under the control of the Hotel, and you acknowledge that the Hotel is not responsible for the accuracy, legality, decency, or any other aspect of the content of such sites. The inclusion of such a business center does not imply endorsement of the site by the Hotel.<br><br><b>RULES OF CONDUCT</b><br>You agree not to use these Services for unlawful purposes or in an offensive manner, including, without limitation, usage that (i) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, or (ii) contains language (sexual or otherwise) of a violent or threatening nature directed at another individual or group of individuals, or victimizes, harasses, degrades, or intimidates an individual or group of individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability. You shall also be prohibited from usage that infringes any patent, trademark, trade secret, copyright, right of publicity, or other proprietary right of any party (collectively, "Intellectual Property"). You shall not introduce any software viruses or any other computer code, files, or programs that are designed or intended to disrupt, damage, or limit the functioning of any software, hardware, or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of any third party. You further agree that you will not knowingly solicit or collect personal information from a minor (anyone under 18 yrs old) without appropriate prior verifiable parental consent. The Hotel makes no representation that materials accessed through the Service are appropriate or available for use in locations outside the United States, and accessing them from territories where their contents are illegal is prohibited.<br><br><b>MONITORING</b><br>The Hotel, its subsidiaries, affiliates, owner or its representatives have no obligation to monitor, track, record, store or disclose your use of the Services, including, without limitation, the URLs of the websites you visit and the data you enter, transmit, or receive, but may do so (i) to comply with legal or regulatory requirements or to assist in law enforcement investigations and procedures; (ii) to operate the Services properly; (iii) to ensure compliance with the terms and conditions herein; or (iv) based on a good faith belief that such monitoring, tracking, recording, storing, or disclosure is otherwise necessary or advisable including, without limitation, if there is reason to believe that such information is necessary to identify, contact or bring legal action against someone who may be causing interference with our rights or properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.<br><br><b>PROPRIETARY RIGHTS</b><br>You acknowledge and agree that all content and materials available to you through these Services are protected by Intellectual Property rights and laws. Reproduction, copying, or redistribution for commercial purposes of any materials or design elements obtained through these Services is strictly prohibited without the express written permission of Intellectual Property owner.<br><br><b>REVISIONS</b><br>The Hotel reserves the right, in it sole discretion, to update or revise these terms from time to time.`,
    }
  },
  filters: {
    phone: function (value) {
      if (!value) return '';
      value = value.toString();
      return '(' + value.substr(0,3) + ') ' + value.substr(3,3) + '-' + value.substr(6,4);
    }
  },
  mounted(){
    // this is checking for a brilliant member and if found we
    // auto auth and present different page, else we pull up form
    let fields = {
      vlan: this.connection_data.vlan_port,
      mac_address: this.connection_data.client_mac,
      ip_address: this.connection_data.client_ip,
      nseid: this.connection_data.nseid
    };

    HTTP.post('langham-member', fields).then(function (response) {
      if (response.data.member) {
        this.memberInfo = response.data.member
        this.loading = false
        this.member = true
      } else {
        this.loading = false
        this.member = false
        this.generateRegistrationMethods();
      }
    }.bind(this))
  },
  methods: {
    generateRegistrationMethods:function(){
      for(var i in this.portal.registration_methods){
        var rm = this.portal.registration_methods[i];
        for(var c in rm.rate_plans){
          var rateplan = rm.rate_plans[c];
          var plan = {
            name: rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: 'rateplan',
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };
          this.registration_methods.push(plan);
        }
      }
      if(this.portal.access_codes.length>0){
        plan = {
          name: 'Access Code',
          type: 'accesscode',
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if( this.registration_methods.length == 1 ){
        this.doc.selected_rm = 0;
      }

      // console.log("index.vue", this.registration_methods)
    },
    // Change selected registration method from emitted data
    changeSelected: function(index){
      this.doc.selected_rm = index;
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function(index){
      this.doc.selected_tos = index;
    },
    // Send registration method details back to parent
    emitRegistrationMethodData:function(emitted){
      // Check the template for v-on:emitRegistrationMethodData
      this.$emit('emitRegistrationMethodData',emitted);
    },
    changeLoadState: function (state) {
      for (let load_state in this.load_states) {
        this.load_states[load_state] = (state == load_state);
      }
    },
    updateJoined: function(value) {
      this.joined = value;
    },
    handleClickedJoin: function() {
      this.changeLoadState('has_custom_portal');
      this.clickedJoin = true;
    }
  }
}
</script>

<style>
  @media only screen and (prefers-color-scheme: dark) {
    :host(:not([data-theme])), :root:not([data-theme]) {

      background-color: white !important;
    }
  }
  @import 'https://cdn.jsdelivr.net/npm/@picocss/pico@2/css/pico.min.css';
  @font-face {
    font-family: 'Futura';
    src: url('./fonts/FuturaStd-Book.eot');
    src: url('./fonts/FuturaStd-Book.eot?#iefix') format('embedded-opentype'),
        url('./fonts/FuturaStd-Book.woff2') format('woff2'),
        url('./fonts/FuturaStd-Book.woff') format('woff'),
        url('./fonts/FuturaStd-Book.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
      font-family: 'langhamEn';
      src: url('./fonts/langham.eot');
      src: url('./fonts/langham.eot?#iefix') format('embedded-opentype'),
          url('./fonts/langham.woff2') format('woff2'),
          url('./fonts/langham.woff') format('woff'),
          url('./fonts/langham.ttf') format('truetype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
  }
  @font-face {
      font-family: 'Baskerville';
      src: url('./fonts/Baskerville.eot');
      src: url('./fonts/Baskerville.eot?#iefix') format('embedded-opentype'),
          url('./fonts/Baskerville.woff2') format('woff2'),
          url('./fonts/Baskerville.woff') format('woff'),
          url('./fonts/Baskerville.ttf') format('truetype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
  }
  @font-face {
      font-family: 'TT Hoves Pro';
      src: url('./fonts/TTHovesRegular.ttf');
      src: url('./fonts/TTHovesRegular.ttf') format('truetype'),
           url('./fonts/TTHovesRegular.woff') format('woff');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
  }

  .error-button {
    background: #FFF;
    border-color: #fd5b5b;
    cursor: pointer;
    border-radius: 32px;
    color: #ac1a1a;
    font-weight: 700;
    text-transform: none;
    width: 20%;
    padding: 8px 0;
    font-size: 1rem;
    line-height: 1rem;
    background: #FFF;
    border: 2px solid #e74343;
    cursor: pointer;
    text-decoration: none;
    margin-top: 10px;
    display: block;
    margin: 0 auto;
  }

  .error-container,
  .loading-container {
    width:  100%;
    margin: 200px auto;
    text-align: center;
    color: #17dbcc;
  }

  .error-container p {
    color: #ac1a1a!important;
    margin-top: 30px;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .loading-container p {
    color: #17dbcc !important;
    margin-top: 30px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .loader {
    width: 50px;
    aspect-ratio: 1;
    color: #17dbcc;
    position: relative;
    animation: l40 .5s infinite alternate;
    margin:  0 auto;
  }
  .loader:before,
  .loader:after {
    content: "";
    position: absolute;
    inset: 0;
    background-size: 25px 25px;
    background-position: 0 0,100% 0,100% 100%,0 100%;
    background-repeat: no-repeat;
  }
  .loader:before {
    background-image:
      radial-gradient(farthest-side at top    left ,currentColor 96%,#0000),
      radial-gradient(farthest-side at top    right,currentColor 96%,#0000),
      radial-gradient(farthest-side at bottom right,currentColor 96%,#0000),
      radial-gradient(farthest-side at bottom left ,currentColor 96%,#0000);
    animation: l40-1 1s infinite;
  }
  .loader:after {
    background-image: 
      radial-gradient(farthest-side at top    left ,#0000 94%,currentColor 96%),
      radial-gradient(farthest-side at top    right,#0000 94%,currentColor 96%),
      radial-gradient(farthest-side at bottom right,#0000 94%,currentColor 96%),
      radial-gradient(farthest-side at bottom left ,#0000 94%,currentColor 96%);
    animation: l40-2 1s infinite;
  }
  @keyframes l40-1 {
    0%,10%,90%,100% {inset:0}
    40%,60% {inset:-10px}
  }
  @keyframes l40-2 {
    0%,40%  {transform: rotate(0)}
    60%,100%{transform: rotate(90deg)}
  }



  h1,h2,h3,h4,h5,h6,p {color:  white;}
  ul, li {list-style: none;}

  h3.title {
    font-family: serif;
    font-style: normal;
    font-weight: bold;
    font-size: 1.45rem;
    line-height: 1.65rem;
    text-align: center;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: #FFFFFF;
    margin-bottom: 0;
  }

  p.subtitle {
    margin-top: 5px;
    font-family: serif;
    font-style: normal;
    font-weight: bold;
    font-size: 1.25rem;
    line-height: 1.4rem;
    text-align: center;
    letter-spacing: 1px;
    color: #FFFFFF;
  }

  #custom_template {
    max-width: 1200px;
    margin: -30px auto;
  }

  .container-fluid {
    max-width: 1200px;
    padding: 0;
  }

  .banner {
    height: 150px;
    margin-bottom: 0px;
    position: relative;
  }

  .banner-img {
    height: 100%;
    overflow: hidden;
    width: 100%;
  }

  .banner-img img {
    display: block;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
  }

  .banner-text {
    top: 43px;
    width: 696px !important;
    color: #fff;
    left: calc(50% - 348px);
    position: absolute;
    text-align: center;
  }

  .banner-text h3::after {
    background: url(img/smallStarBlue.svg) no-repeat;
    background-size: 100%;
    content: "";
    margin-left: 8px;
    position: absolute;
    height: 20px;
    width: 20px;
    margin-top: 3px;
  }

  .logo {
    height: 30px;
    margin: 15px auto;
  }

  .bottom-left-ribbon {
    background: url(img/backgroundStarWhiteBig.svg) no-repeat;
    background-size: 18%;
    background-position: 0 100%;
    bottom: -1px;
    height: 100%;
    left: 0;
    position: absolute;
    width: 100%;
  }

  footer {
    background: #151515;
    border-radius: 0 50px 0 0;
    width: 100%;
    margin-top: 50px;
  }

  .logo-container {
    background-color: #595d5f;
    border-bottom-left-radius: 50px;
    border-top-right-radius: 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 5pc 0 72px;
    width: 100%;
  }

  .brilliant-logo {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    margin-bottom: 60px;
  }

  .brilliant-logo img {
    width:  261px;
  }

  .icon-content {
    padding: 0 50px;
  }

  .icon-content ul {
    -ms-flex-pack: distribute;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    gap: 60px 1pc;
    justify-content: space-around;
    list-style-type: none;
    margin: 0 auto;
    max-width: 100%;
    padding: 0;
    width: 100%;
  }

  .icon-content li a {
    display: inline-block;
    text-decoration: none;
  }

  .icon-content li a img {
    height: auto;
    max-height: 75px;
    width: auto;
  }

  .footer-bottom-container {
    background-color: #151515;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
    width: 100%;
    text-align: left;
    padding: 87.5px 60px 100px;
  }

  .bottom-address-header {
    font-family: TTHovesRegular, Arial;
    font-size: 1.375rem;
    font-weight: 400;
    font-weight: 700;
    letter-spacing: 1px;
    letter-spacing: 2px;
    line-height: 1.25rem;
    line-height: 20px;
    padding: 29px 0 0 25px;
  }

  .address-list {
    font-family: TTHovesRegular, Arial;
    font-size: .875rem;
    font-size: .75rem;
    font-weight: 400;
    letter-spacing: 1px;
    line-height: 1.25rem;
    line-height: 20px;
    margin: 0;
    padding: 10px 69px 0 25px;
  }

  .contact-infobar p a {
    font-family: TTHovesRegular, Arial;
    font-size: .875rem;
    font-size: .75rem;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 1.25rem;
    line-height: 20px;
    padding: 20px 69px 28px 25px;
    color: white;
    text-decoration: none;
    display: block;
  }

  .bottom-separator {
    border: 1px solid hsla(0, 0%, 100%, .2);
    margin: 0 20px;
  }

  .social-icon {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-family: TTHovesRegular, Arial;
    font-size: .875rem;
    font-size: .75rem;
    font-weight: 400;
    letter-spacing: 1px;
    letter-spacing: .08px;
    line-height: 1.25rem;
    line-height: 20px;
    margin: 17px 0 18px 25px;
  }

  .social-icon ul {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    list-style-type: none;
    margin: 0;
    padding-left: 0;
  }

  .social-icon ul li img {
    color: #fff;
    height: auto;
    padding-left: 10px;
    width: auto;
  }

  .bottom-content-navigator,
  .navigation-list,
  .copyrights-list p {
    font-family: TTHovesRegular, Arial;
    font-size: 1.5rem;
    font-size: .6875rem;
    font-weight: 400;
    letter-spacing: 1px;
    line-height: 1.25rem;
    line-height: 20px;
    margin: 40px 0 25px 25px;
  }

  .bottom-content-navigator ul,
  .copyrights-list p {
    padding: 0;
    margin: 0;
  }

  .copyrights-list p { margin-left: 25px; }
  .copyrights-list a {color:  white; text-transform: uppercase; text-decoration: none;}

  .navigation-list {padding-left: 0;}

  .bottom-content-navigator ul li,
  .navigation-list  li{
    display: inline-block;
    margin-right: 20px;
  }

  .bottom-content-navigator ul li a,
  .navigation-list li a {
    display: list-item;
    color: white;
    text-decoration: none;
    font-size: .875rem;
  }

  .mobile-banner {display: none;}

  @media (max-width: 768px) {
    .large-banner {display: none !important;}
    .mobile-banner {display: block !important;}
  }
</style>
